export default __webpack_public_path__ + "static/imao-050fb7fa54ce787957662526d314c911.svg";